/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Name_LabelInputs */

const en_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Name`)
};

const fr_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du projet`)
};

const de_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektname`)
};

const it_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del progetto`)
};

const ru_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название проекта`)
};

const es_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del proyecto`)
};

const zh_cn2_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目名称`)
};

const ja_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト名`)
};

const hi_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना का नाम`)
};

const pt_pt2_new_project_name_label = /** @type {(inputs: New_Project_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do projeto`)
};

/**
* | output |
* | --- |
* | "Project Name" |
*
* @param {New_Project_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_name_label = /** @type {((inputs?: New_Project_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_name_label(inputs)
	if (locale === "de") return de_new_project_name_label(inputs)
	if (locale === "it") return it_new_project_name_label(inputs)
	if (locale === "ru") return ru_new_project_name_label(inputs)
	if (locale === "es") return es_new_project_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_name_label(inputs)
	if (locale === "ja") return ja_new_project_name_label(inputs)
	if (locale === "hi") return hi_new_project_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_name_label(inputs)
	return en_new_project_name_label(inputs)
});